export type TableSortDirection = "DESC" | "ASC" | "INITIAL";

export interface TableHeaderOptions {
  width?: string | number;
  icon?: string;
  list: boolean;
  map: TableHeaderMap;
  tile: boolean;
}

export enum TableHeaderMap {
  NONE,
  POPUP,
  PIN,
}

export class TableHeader {
  public name: string;
  public pfx: string;
  public label: string;
  public visible: boolean;
  public template: string | null;
  public sort: {
    direction: TableSortDirection;
    column: string | null;
  } | null;

  public options: TableHeaderOptions;

  public constructor(name: string, label: string, options: TableHeaderOptions) {
    this.name = name;
    this.pfx = name.substring(0, 3);
    this.label = label;
    this.visible = true;
    this.sort = null;
    this.template = null;

    this.options = {
      width: "initial",
      icon: "",
      ...options,
    };
  }
}
